import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import FormRow from "./FormRow";
import { useTranslation } from 'react-i18next';

interface RecurringClassFieldsProps {
  form: UseFormReturn<any>;
}

const RecurringClassFields = ({ form }: RecurringClassFieldsProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4 rounded-lg border p-4">
      <FormRow>
        <FormField
          control={form.control}
          name="repeatEvery"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('classForm.repeatEvery')}</FormLabel>
              <FormControl>
                <Input type="number" min="1" max="20" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="repeatPeriod"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('classForm.repeatPeriod')}</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder={t('classForm.repeatPeriod')} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Week">{t('classForm.repeatPeriodOptions.week')}</SelectItem>
                  <SelectItem value="Month">{t('classForm.repeatPeriodOptions.month')}</SelectItem>
                  <SelectItem value="Year">{t('classForm.repeatPeriodOptions.year')}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </FormRow>
      <FormField
        control={form.control}
        name="repeatMaxEvents"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('classForm.maxEvents')}</FormLabel>
            <FormControl>
              <Input type="number" min="1" max="12" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default RecurringClassFields;